import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiUrl } from '../config/api';
import * as XLSX from 'xlsx';
import './GestionProducto.css';

function TTarjeta({ usuario }) {
    const [tarjetas, setTarjetas] = useState([]);
    const [tarjetasFiltradas, setTarjetasFiltradas] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);

    const [formulario, setFormulario] = useState({
        idTarjeta: '',
        nomTarjeta: '',
        obs: ''
    });

    // Paginacion
    const [paginaActual, setPaginaActual] = useState(1);
    const [itemsPorPagina, setItemsPorPagina] = useState(10);

    useEffect(() => { cargarTarjetas(); }, []);
    useEffect(() => { filtrarTarjetas(); }, [busqueda, tarjetas]);

    const cargarTarjetas = async () => {
        try {
            const r = await axios.get(getApiUrl('/api/ttarjeta'));
            setTarjetas(r.data);
        } catch (e) { console.error('Error:', e); alert('Error al cargar tarjetas'); }
    };

    const filtrarTarjetas = () => {
        if (!busqueda) { setTarjetasFiltradas(tarjetas); setPaginaActual(1); return; }
        setTarjetasFiltradas(tarjetas.filter(t =>
            t.idTarjeta?.toLowerCase().includes(busqueda.toLowerCase()) ||
            t.nomTarjeta?.toLowerCase().includes(busqueda.toLowerCase()) ||
            t.obs?.toLowerCase().includes(busqueda.toLowerCase())
        ));
        setPaginaActual(1);
    };

    const abrirModalNuevo = () => {
        setFormulario({ idTarjeta: '', nomTarjeta: '', obs: '' });
        setModoEdicion(false);
        setModalAbierto(true);
    };

    const abrirModalEditar = (t) => {
        setFormulario({ idTarjeta: t.idTarjeta, nomTarjeta: t.nomTarjeta, obs: t.obs || '' });
        setModoEdicion(true);
        setModalAbierto(true);
    };

    const cerrarModal = () => { setModalAbierto(false); };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formulario.idTarjeta.trim()) { alert('El ID de tarjeta es obligatorio'); return; }
        if (!formulario.nomTarjeta.trim()) { alert('El nombre de la tarjeta es obligatorio'); return; }

        try {
            if (modoEdicion) {
                await axios.put(getApiUrl(`/api/ttarjeta/${formulario.idTarjeta}`), formulario);
                alert('Tarjeta actualizada exitosamente');
            } else {
                await axios.post(getApiUrl('/api/ttarjeta'), formulario);
                alert('Tarjeta creada exitosamente');
            }
            cargarTarjetas();
            cerrarModal();
        } catch (error) {
            const msg = error.response?.data || 'Error al guardar';
            alert(typeof msg === 'string' ? msg : 'Error al guardar');
        }
    };

    const eliminar = async (id) => {
        if (!window.confirm('Esta seguro de eliminar la tarjeta ' + id + '?')) return;
        try {
            await axios.delete(getApiUrl(`/api/ttarjeta/${id}`));
            alert('Tarjeta eliminada');
            cargarTarjetas();
        } catch (error) {
            const msg = error.response?.data || 'Error al eliminar';
            alert(typeof msg === 'string' ? msg : 'Error al eliminar');
        }
    };

    const exportarExcel = () => {
        const d = tarjetasFiltradas.map(t => ({
            'ID': t.idTarjeta, 'Nombre': t.nomTarjeta, 'Observaciones': t.obs
        }));
        const ws = XLSX.utils.json_to_sheet(d); const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Tarjetas'); XLSX.writeFile(wb, 'tarjetas.xlsx');
    };

    // Paginacion
    const indiceUltimo = paginaActual * itemsPorPagina;
    const indicePrimero = indiceUltimo - itemsPorPagina;
    const tarjetasActuales = tarjetasFiltradas.slice(indicePrimero, indiceUltimo);
    const totalPaginas = Math.ceil(tarjetasFiltradas.length / itemsPorPagina);

    return (
        <div className="present-container">
            <div className="header-seccion">
                <h2>Tarjetas de Credito/Debito</h2>
                <div className="acciones-header">
                    <input type="text" className="input-busqueda" placeholder="Buscar..." value={busqueda} onChange={(e) => setBusqueda(e.target.value)} />
                    <button className="btn btn-nuevo" onClick={abrirModalNuevo}>+ Nueva Tarjeta</button>
                    <button className="btn btn-exportar" onClick={exportarExcel}>Exportar Excel</button>
                </div>
            </div>

            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead><tr>
                        <th>ID</th><th>Nombre</th><th>Observaciones</th><th>Acciones</th>
                    </tr></thead>
                    <tbody>
                        {tarjetasActuales.length === 0 ? (
                            <tr><td colSpan="4" className="sin-datos">No hay tarjetas para mostrar</td></tr>
                        ) : tarjetasActuales.map(t => (
                            <tr key={t.idTarjeta}>
                                <td><strong>{t.idTarjeta}</strong></td>
                                <td>{t.nomTarjeta}</td>
                                <td>{t.obs}</td>
                                <td>
                                    <button onClick={() => abrirModalEditar(t)} className="btn-accion" title="Editar">✏️</button>
                                    <button onClick={() => eliminar(t.idTarjeta)} className="btn-accion" title="Eliminar">🗑️</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Paginacion */}
            <div className="paginacion-container">
                <div className="paginacion-info">
                    <span>Mostrando {tarjetasFiltradas.length > 0 ? indicePrimero + 1 : 0} a {Math.min(indiceUltimo, tarjetasFiltradas.length)} de {tarjetasFiltradas.length}</span>
                    <select value={itemsPorPagina} onChange={(e) => { setItemsPorPagina(Number(e.target.value)); setPaginaActual(1); }} className="select-registros">
                        <option value={10}>10</option><option value={25}>25</option><option value={50}>50</option>
                    </select>
                </div>
                <div className="paginacion-controles">
                    <button onClick={() => setPaginaActual(1)} disabled={paginaActual === 1} className="btn-paginacion">|&lt;</button>
                    <button onClick={() => setPaginaActual(p => p - 1)} disabled={paginaActual === 1} className="btn-paginacion">&lt;</button>
                    {[...Array(totalPaginas)].map((_, i) => {
                        const n = i + 1;
                        if (n === 1 || n === totalPaginas || (n >= paginaActual - 1 && n <= paginaActual + 1)) {
                            return <button key={n} onClick={() => setPaginaActual(n)} className={`btn-numero-pagina ${paginaActual === n ? 'activo' : ''}`}>{n}</button>;
                        }
                        if (n === paginaActual - 2 || n === paginaActual + 2) return <span key={n}>...</span>;
                        return null;
                    })}
                    <button onClick={() => setPaginaActual(p => p + 1)} disabled={paginaActual >= totalPaginas} className="btn-paginacion">&gt;</button>
                    <button onClick={() => setPaginaActual(totalPaginas)} disabled={paginaActual >= totalPaginas} className="btn-paginacion">&gt;|</button>
                </div>
            </div>

            {/* Modal */}
            {modalAbierto && (
                <div className="modal-overlay">
                    <div className="modal-contenido" style={{ maxWidth: '500px' }}>
                        <div className="modal-header">
                            <h3>{modoEdicion ? 'Editar Tarjeta' : 'Nueva Tarjeta'}</h3>
                            <button onClick={cerrarModal} className="btn-cerrar">&times;</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>ID Tarjeta * (max 3 caracteres)</label>
                                <input type="text" value={formulario.idTarjeta}
                                    onChange={(e) => setFormulario({...formulario, idTarjeta: e.target.value.toUpperCase()})}
                                    maxLength={3} disabled={modoEdicion}
                                    placeholder="Ej: VIS, MAS, DIN"
                                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px',
                                        backgroundColor: modoEdicion ? '#f0f0f0' : 'white', textTransform: 'uppercase' }} />
                            </div>
                            <div className="form-group">
                                <label>Nombre * (max 15 caracteres)</label>
                                <input type="text" value={formulario.nomTarjeta}
                                    onChange={(e) => setFormulario({...formulario, nomTarjeta: e.target.value})}
                                    maxLength={15} placeholder="Ej: VISA, MASTERCARD"
                                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                            </div>
                            <div className="form-group">
                                <label>Observaciones (max 50 caracteres)</label>
                                <input type="text" value={formulario.obs}
                                    onChange={(e) => setFormulario({...formulario, obs: e.target.value})}
                                    maxLength={50}
                                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                            </div>
                            <div className="modal-footer">
                                <button type="button" onClick={cerrarModal} className="btn btn-cancelar">Cancelar</button>
                                <button type="submit" className="btn btn-guardar">{modoEdicion ? 'Actualizar' : 'Guardar'}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default TTarjeta;
